import styled from '@emotion/styled';
import theme from '../theme';
import { LangContext } from '../context/LangContext'; 
import { DeviceContext } from '../context/DeviceContext'; 
import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function FixedMenu() {

    const { selectLanguage } = useContext(LangContext);
    const { isMobile } = useContext(DeviceContext);
    
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
          setScrollY(window.scrollY);
    
          const throttleTimeout = 800;
          let throttleTimer;
          if (!throttleTimer) {
            throttleTimer = setTimeout(() => {
              throttleTimer = null;
              //console.log('스크롤 위치:', scrollY);
            }, throttleTimeout);
          }
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, [scrollY]);
    
      let dataArr = [];
    
      if(selectLanguage === '한국어'){
        //dataArr = ['공식 트레일러','디스코드','트위터','헬프데스크','마이그레이션'];
        dataArr = ['공식 트레일러','디스코드','트위터','헬프데스크'];
      }else{
        //dataArr = ['TRAILER','DISCORD','TWITTER','HELP DESK','MIGRATION'];
        dataArr = ['TRAILER','DISCORD','TWITTER','HELP DESK'];
      }


    const Container = styled.div`                    
        position:fixed;
        transition: top 1s ease 0s;
        right:50px;
        z-index:10;
        
        ${theme.breakpoints.xl} {
          display:none;
        }
    `;

    const FixedMenuTop = styled.div`
        padding:20px 18px;
        background: rgba(0, 0, 0, 0.70);
        backdrop-filter: blur(5px);
        border-radius: 18px;
        text-align:center;

        img{        
            height:92px;
            margin-bottom:16px;
        }

        ${theme.breakpoints.xl_1920} {
          img{            
            margin-bottom:4px;
          }
        }
    `;

    const FixedMenuTopTitle = styled.div`
        font-size:18px;        
        line-height: 165%;

        ${theme.breakpoints.xl_1920} {
          font-size:16px;
        }
    `;

    const FixedMenuBottom = styled.div`
        margin-top:16px;
        padding:20px;
        background: rgba(0, 0, 0, 0.70);
        backdrop-filter: blur(5px);
        border-radius: 18px;
        display: flex;
        flex-direction: column;
        // gap:40px;

        //${theme.breakpoints.xl_1920} {
        //  gap:0px;
        //}
    `;

    const FixedMenuBottomContent = styled.div`
        text-align: center;
        margin: 20px auto;

        img{
            margin-bottom: 8px;
            height:64px;
        }

        &:last-child{
            margin-bottom: 20px;
        }

        a{
          text-decoration:none;
        }

        
        // ${theme.breakpoints.xl_1920} {
        //   img{
        //       margin-bottom: 4px;
        //   }
        // }
    `;

    const FixedMenuBottomTitle = styled.div`
        font-size:16px;
        color:white;
        text-decoration:none;
    `;


  return (
    <>
      {!isMobile &&      
      <Container style={ scrollY > 3000 ? {top:'90px'} : {top:'140px'}}>
        {/*
          <FixedMenuTop>
            <Link to="https://play.google.com/store/apps/details?id=com.sandboxgame.mtdz" target='_blank' style={{textDecoration:'none', color:'#FF7A19'}}>
              <img src="/images/logo/gameDownload.png" alt="메뉴"/>             
              <FixedMenuTopTitle>
                {selectLanguage === '한국어' ? '게임 다운로드' : 'DOWNLOAD'}
              </FixedMenuTopTitle>
              </Link>
          </FixedMenuTop>
        */}
          <FixedMenuBottom>
          {/* <FixedMenuBottomContent>
              <Link to={`${selectLanguage === '한국어' 
                  ? '/docs/Wemix_migration_guide.pdf'
                  : '/docs/Wemix_migration_guide.pdf'}`
                } target="_blank">
                <img src="/images/icon/migration.png" alt="메뉴"/> 
                <FixedMenuBottomTitle>{dataArr[4]}</FixedMenuBottomTitle>
              </Link>
            </FixedMenuBottomContent> */}
            <FixedMenuBottomContent>
              <Link to={`${selectLanguage === '한국어' 
                  ? 'https://youtu.be/4Q1ttZBLE6E'
                  : 'https://youtu.be/k6Umdj3p2pY'}`
                } target="_blank">
                <img src="/images/icon/trailer.png" alt="메뉴"/> 
                <FixedMenuBottomTitle>{dataArr[0]}</FixedMenuBottomTitle>
              </Link>
            </FixedMenuBottomContent>
            <FixedMenuBottomContent>
              <Link to="https://discord.gg/metatoyworld" target="_blank">
                <img src="/images/icon/discord.png" alt="메뉴"/>
                <FixedMenuBottomTitle>{dataArr[1]}</FixedMenuBottomTitle>
              </Link>
            </FixedMenuBottomContent>
            {
              selectLanguage === '한국어'
              ? 
              <FixedMenuBottomContent>
                <Link to="https://game.naver.com/lounge/Meta_Toy_DragonZ_SAGA/home" target="_blank">
                  <img src="/images/icon/zzz.png" alt="메뉴"/>
                  <FixedMenuBottomTitle>공식 커뮤니티</FixedMenuBottomTitle>
                </Link>
              </FixedMenuBottomContent>
              :
              <FixedMenuBottomContent>
                <Link to="https://twitter.com/MetaToyDragonZ" target="_blank">
                  <img src="/images/icon/x.png" alt="메뉴"/>
                  <FixedMenuBottomTitle>{dataArr[2]}</FixedMenuBottomTitle>
                </Link>
              </FixedMenuBottomContent>
            }
            
            <FixedMenuBottomContent>
                <Link to={selectLanguage === '한국어' 
                  ? 'https://sandboxnetwork.zendesk.com/hc/ko/requests/new?ticket_form_id=22568004516633'
                  : 'https://sandboxnetwork.zendesk.com/hc/en-us/requests/new?ticket_form_id=22568004516633'}
                  target="_blank">
                  <img src="/images/icon/help.png" alt="메뉴"/>
                  <FixedMenuBottomTitle>{dataArr[3]}</FixedMenuBottomTitle>
                </Link>                            
            </FixedMenuBottomContent>
          </FixedMenuBottom>
      </Container>
      }
    </>
  )
}
